export const AuditTab = ({ audit }) => (
  <div className="overflow-x-auto border border-border" data-testid="audit-view">
    <table className="dense-table w-full min-w-[760px]">
      <thead><tr><th>#</th><th>At</th><th>Entity</th><th>Action</th><th>Detail</th><th>Hash</th></tr></thead>
      <tbody>
        {audit.map((a) => (
          <tr key={a.id} className="row-in">
            <td className="num">{a.seq}</td>
            <td className="num whitespace-nowrap">{new Date(a.at).toLocaleString("en-IN")}</td>
            <td>{a.entity}</td><td>{a.action}</td>
            <td className="num max-w-[280px] truncate text-[11px] text-muted-foreground">{JSON.stringify(a.after || {})}</td>
            <td className="num text-[10px] text-muted-foreground">{(a.hash || "").slice(0, 12)}…</td>
          </tr>
        ))}
        {audit.length === 0 && <tr><td colSpan={6} className="text-muted-foreground">No audit records yet.</td></tr>}
      </tbody>
    </table>
  </div>
);
